import React from 'react';
import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <div className="site-footer-name">
            <img src="/logo.png" alt="" />
            <span>Prop Doc</span>
          </div>
          <p>
            Plain-English analysis of Victorian Section 32/Contract of Sale documents,
            so you know what you're buying before you sign.
          </p>
        </div>

        <nav className="site-footer-col" aria-label="Product">
          <h3>Product</h3>
          <ul>
            <li><Link to="/analyze">Analyse a document</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/history">My reports</Link></li>
          </ul>
        </nav>

        <nav className="site-footer-col" aria-label="Learn">
          <h3>Learn</h3>
          <ul>
            <li><Link to="/guides/what-is-a-section-32">What is a Section 32?</Link></li>
            <li><Link to="/guides/section-32-checklist">Section 32 checklist</Link></li>
            <li><Link to="/guides/easements-explained">Easements explained</Link></li>
            <li><Link to="/#faq">FAQ</Link></li>
          </ul>
        </nav>

        <div className="site-footer-col">
          <h3>Good to know</h3>
          <ul className="site-footer-notes">
            <li>Documents are processed securely and deleted after analysis.</li>
            <li>Reports stay on your device. Pro subscribers can sign in by email on any device.</li>
            <li>Questions? Email <a href="mailto:support@propdoc.site">support@propdoc.site</a></li>
          </ul>
        </div>
      </div>

      <div className="site-footer-legal">
        <p>
          Prop Doc provides automated document analysis for informational purposes only.
          It is not legal advice — always consult a qualified conveyancer or solicitor
          before purchasing property.
        </p>
        <p>© {new Date().getFullYear()} Prop Doc</p>
      </div>
    </footer>
  );
}
